import './OFNotifications.scss'

import React from 'react'
import { observer, inject } from 'mobx-react'
import { AppStore } from '~/stores/AppStore'
import { Notification } from './Notification'
import { Controller } from './Controller'

@inject('store')
@observer
export class OFNotifications extends React.Component<{
  store?: AppStore
}> {
  public controller = new Controller(this.props.store)

  private renderNotifications = () => {
    const { notificationsPopover, notificationsMuted } = this.props.store
    const { calculateOffset, maxUnfoldedCards, triggerCollapse, destroyAllNotifications, isExpanded, isFolded, destroy } = this.controller

    // Dont show any notifications if muted or empty
    if (notificationsMuted() || notificationsPopover.length === 0) {
      return null
    }

    const notifications = []
    let totHeight = 0
    let closeAllOffset = 0

    notificationsPopover.forEach((n, i) => {
      notifications.push(<Notification controller={this.controller} key={n.id} data={n} index={i} totHeight={totHeight} />)

      if (n.height) {
        totHeight += n.height
      }
    })

    // Calculate the offset of the close all button to make sure is under the collapsed cards
    if (notificationsPopover.length > maxUnfoldedCards) {
      closeAllOffset = calculateOffset(maxUnfoldedCards)
    }

    return (
      <div className='OFNotificationContainer'>
        <div
          className='notifications'
          onMouseLeave={() => {
            if (isExpanded) {
              triggerCollapse()
            }
          }}
          style={{ opacity: destroy ? 0 : 1 }}
        >
          {notifications}
        </div>
        {isFolded && !destroy && (
          <div className='closeAll' onClick={() => destroyAllNotifications(true)} style={{ top: closeAllOffset + 25 }}>
            Close All
          </div>
        )}
      </div>
    )
  }

  public render() {
    return this.renderNotifications()
  }
}
